import React from 'react';
import { useSelector } from 'react-redux';

import { Grid, Typography } from '@material-ui/core';

import { useStyles } from './styles';

export default function RestrictionsView() {
  const styles = useStyles();

  const { restrictions, custom_settings } = useSelector(state => state.provisionalReceiptConfig);

  return(
    <Grid container>
      <Grid item xs={12} style={{ marginBottom: 20, borderBottom: '1px solid #E4E7EA' }}>
        <Typography color="primary">
          <b>Restrições de envio de NFS-e de cada prefeitura</b>
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="h6" color="primary" className={styles.text}>
          <b>Cliente/Tomador:</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Obrigatoriedade no cadastro:{' '}
          <b>{restrictions?.requiredClient ? 'Sim' : 'Não'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Obrigatoriedade no nome:{' '}
          <b>{restrictions?.requiredClientName ? 'Sim' : 'Não'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Obrigatoriedade no CPF/CNPJ:{' '}
          <b>{restrictions?.requiredClientDocumentId ? 'Sim' : 'Não'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Obrigatoriedade no endereço:{' '}
          <b>{restrictions?.requiredClientAddress ? 'Sim' : 'Não'}</b>
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="h6" color="primary" className={styles.text}>
          <b>Empresa:</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          CNAE:{' '}
          <b>{restrictions?.requiredCnae ? 'Sim' : 'Não'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Código Serviço:{' '}
          <b>{restrictions?.requiredMunicipalServiceCode ? 'Sim' : 'Não'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Código Item Lista Serviço:{' '}
          <b>{restrictions?.requiredServiceItem ? 'Sim' : 'Não'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Natureza de Tributação:{' '}
          <b>{restrictions?.taxationNature ? 'Sim' : 'Não'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Código NBS:{' '}
          <b>{custom_settings?.requiredNbsCode ? 'Ativado' : 'Desativado'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Código IBSCBS:{' '}
          <b>{custom_settings?.requiredIbscbsCode ? 'Ativado' : 'Desativado'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Código IBSCBS CCT:{' '}
          <b>{custom_settings?.requiredIbscbsCctCode ? 'Ativado' : 'Desativado'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Versão Esquema:{' '}
          <b>{custom_settings?.requiredSchemaVersion ? 'Ativado' : 'Desativado'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Finalidade NFSe:{' '}
          <b>{restrictions?.nfsePurpose ? 'Ativado' : 'Desativado'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Percentual Estadual:{' '}
          <b>{custom_settings?.percentualEstadual ? 'Ativado' : 'Desativado'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Percentual Municipal:{' '}
          <b>{custom_settings?.percentualMunicipal ? 'Ativado' : 'Desativado'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Percentual CBS:{' '}
          <b>{custom_settings?.percentualCbs ? 'Ativado' : 'Desativado'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Anexo Simples Nacional:{' '}
          <b>{custom_settings?.nationalAttachment ? 'Ativado' : 'Desativado'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          Aliquota Simples Nacional:{' '}
          <b>{custom_settings?.nationalAliquot ? 'Ativado' : 'Desativado'}</b>
        </Typography>
        <br />
        <Typography variant="h6" color="primary" className={styles.text}>
          <b>Cancelamento de NFS-e</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          NF-e precisa do cadastro do cliente:{' '}
          <b>{restrictions?.requiredClientToCancel ? 'Sim' : 'Não'}</b>
        </Typography>
        <Typography variant="h6" color="primary" className={styles.text}>
          NF-e precisa do CPF/CNPJ do cliente:{' '}
          <b>{restrictions?.requiredClientDocumentIdToCancel ? 'Sim' : 'Não'}</b>
        </Typography>
      </Grid>
    </Grid>
  );
}